import { Box, Skeleton, Typography } from "@mui/material";

type Props = {
  labels: Array<string>;
};

export const ValueItemsSkeleton = ({ labels }: Props) => (
  <>
    {labels.map((label) => (
      <Box
        key={label}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography fontWeight={400}>{label}</Typography>
        <Skeleton height={24} width={Math.floor(Math.random() * 50) + 75} />
      </Box>
    ))}
  </>
);
